import aws from './aws';
import azure from './azure';
import dashify from './dashify';
import dashifyDocs from './dashify-docs';
import apm from './apm';
import home from './home';
import cost from './cost';
import aiops from './aiops';
import biq from './biq';

export default [...cost, ...apm, ...aws, ...azure, ...dashify, ...dashifyDocs, ...home, ...aiops, ...biq];
